"use client";

import env from "@/lib/env-public";

export function overrideAccountDomain(lookup: string): string {
  if (typeof window === "undefined" || !env.NEXT_PUBLIC_DEVELOPER_MODE) {
    return lookup;
  }

  const hash = window.location.hash;
  if (hash.length > 0) {
    // Remove the # character and parse the hash
    const hashParams = hash.substring(1);

    // Split by & to handle multiple parameters
    const params = hashParams.split("&");

    // Look for d to replace the domain e.g. localhost:3000/sign-in#d=<customer_name>
    for (const param of params) {
      const [key, value] = param.split("=");
      if (key === "d" && value) {
        const neticLookup = decodeURIComponent(value);
        return neticLookup;
      }
    }
  }

  return lookup;
}
